// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonFields = {
  id: "ID",
  userId: "用户ID",
  username: "用户名",
  displayName: "显示名称",
  role: "角色",
  status: "状态",
  type: "类型",
  examId: "考试 ID",
  attemptId: "作答 ID",
  module: "模块",
  action: "动作",
  resource: "资源",
  resourceType: "资源类型",
  resourceId: "资源 ID",
  relation: "关联",
  sequenceNo: "题号",
  order: "顺序",
  limit: "条数",
  difficulty: "难度",
  code: "编号",
  identifier: "标识",
  name: "名称",
  description: "描述",
  title: "标题",
  organization: "组织",
  organizationUnit: "组织节点",
  phone: "手机号",
  expiresAt: "到期时间",
  platformRoles: "平台角色",
  applicationRolesSummary: "应用角色摘要",
  organizationMemberships: "组织归属",
  platformRoleAssignments: "平台角色授予详情",
  paperType: "卷型",
  questionType: "题型",
  questionCount: "题目数",
  totalScore: "总分",
  durationMinutes: "建议时长",
  field: "字段",
  fromValue: "旧值",
  toValue: "新值",
  jsonField: "JSON 字段",
  path: "路径",
  changeType: "变更类型",
  versionNo: "版本",
  versionedCode: "版本编号",
  verdict: "判定",
  judgeStatus: "评测状态",
  language: "语言",
  score: "得分",
  passedCases: "通过用例",
  stdout: "标准输出（stdout）",
  stderr: "错误输出（stderr）",
  createdBy: "创建人",
  createdAt: "创建时间",
  updatedBy: "修改人",
  updatedAt: "修改时间",
  actions: "操作",
} as const;
